import { Icon, type TIconProps } from '~/components/icon'

import type { TButtonSizes, TButtonVariants } from '../../types'

import { useButtonProps } from '../../hooks/use-button-props'
import { useMemo } from 'react'
import { View } from 'react-native'

interface IButtonIconProps extends Pick<TIconProps, 'symbol'> {
  iconColor?: TIconProps["color"]
  testID?: string
}

export function ButtonIcon({ iconColor, symbol, testID }: IButtonIconProps) {
  const { variant = 'brand-primary', size = 'md', disabled } = useButtonProps()

  const isDisabled = !!disabled

  const iconColorMapping: Record<TButtonVariants, TIconProps['color']> = {
    'brand-primary': 'colorTextNeutralInverse',
    'neutral-secondary': 'colorTextNeutralDefault',
    'neutral-tertiary': 'colorTextNeutralDefault',
  }

  const iconSizeMapping: Record<TButtonSizes, TIconProps['size']> = {
    md: 'extra-small',
    ml: 'small',
    lg: 'small',
    xl: 'small',
  }

  const color = useMemo(() => {
    if (isDisabled) return "colorTextNeutralDisabled"
    if (iconColor) return iconColor

    return iconColorMapping[variant]

  }, [isDisabled, variant])

  return (
    <View style={{ position: "absolute" }}>
      <Icon
        symbol={symbol}
        size={iconSizeMapping[size]}
        color={color}
        testID={testID}
      />
    </View>
  )
}
